/**
 * Featured Book Modal 
 *
 * Component to handle the View Details modal.
 * 
 */

/**
 * React dependencies
 */

import React, { useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { trackBookInfoClick } from '../../analytics';

/**
 * DWT hooks
 */

import useModal from '../../hooks/useModal';

/**
 * DWT components
 */
import Modal from '../Modal/Modal';

const context = {
  featureBy: 'books',
  allowedMetadataFields: JSON.stringify( [ 'Title', 'Contributor Name', 'Description' ] ),
  entry: 'manual',
  module: 'featured_book',
};

const FeaturedBookModalTrigger = ({ attributes }) => {
  const [ open, setOpen ] = useState( false );
  const modalRef = useRef( null );
  const {
    modalClass,
    modalData,
    modalType,
    onClickOpenModal,
    onClickCloseModal
  } = useModal( [ attributes ], modalRef, context );

  const handleClick = ( e ) => {
    e.preventDefault();
    trackBookInfoClick( attributes, context );
    setOpen( true );
    onClickOpenModal( attributes.isbn, 'books' );
  };

  return (
    <>
      <button
        className="featured-book__view-details"
        onClick={handleClick}
        aria-label={`View Details for ${attributes.title}`}
      >
        +View Details
      </button>
      {open && (
        <Modal
          context={context}
          modalData={modalData}
          modalClass={modalClass}
          modalType={modalType}
          onClose={onClickCloseModal}
          ref={modalRef}
        />
      )}
    </>
  );
};

const renderFeaturedBookModalTrigger = () => {
  const btns = document.querySelectorAll( '.featured-book__view-details' );
  btns.forEach( ( btn ) => {
    if ( btn._reactRootContainer ) return;
    const attributes = JSON.parse( btn.getAttribute( 'data-attributes' ) );
    const container = document.createElement( 'span' );
    btn.replaceWith( container );
    const root = createRoot( container );
    root.render( <FeaturedBookModalTrigger attributes={attributes} /> );
  });
};

export default renderFeaturedBookModalTrigger;